import toast from 'react-hot-toast';

const toaster = {
  success: (message: string) => toast.success(message),
  error: (message: string) => toast.error(message),
  warning: (message: string) =>
    toast(message, {
      icon: '⚠️',
      style: {
        background: '#FFF7E6',
        border: '1px solid #FFE58F',
        color: '#D46B08',
      },
    }),
};

export default toaster;
